import type { RouteObject } from "react-router-dom";
import { ImportsPage } from "./ImportsPage";
import { WizardPage } from "./WizardPage";
import { GoLivePage } from "./GoLivePage";

/** Mounted by the settings routes (listed edit): `/settings/import` and `/settings/import/:id`, guarded by `settings.imports_view`. */
export const routes: RouteObject[] = [
  { path: "settings/import", element: <ImportsPage /> },
  { path: "settings/import/:id", element: <WizardPage /> },
  // pilot-golive: the owner's read-only copy of the go-live checklist, guarded by settings.golive_view.
  { path: "settings/go-live", element: <GoLivePage /> },
];
